export default {
  serviceType: [
    {
      value: 1,
      label: "现代服务*外包服务"
    },
    {
      value: 2,
      label: "现代服务*技术服务"
    },
    {
      value: 3,
      label: "现代服务*设计服务费"
    },
    {
      value: 4,
      label: "现代服务*家政服务"
    },
    {
      value: 5,
      label: "研发技术服务*技术咨询"
    },
    {
      value: 6,
      label: "物流辅助服务*你给我运输代理服务"
    },
    {
      value: 7,
      label: "企业管理服务*其他企业管理服务"
    },
    {
      value: 8,
      label: "信息技术服务*软件测试服务"
    }
  ],
  status: [
    {
      value: 2,
      label: "审核通过"
    },
    {
      value: 5,
      label: "驳回"
    }
  ],
  statesValue: [
    {
      value: 3,
      label: "线下支付"
    },
    {
      value: 5,
      label: "驳回"
    }
  ],
  statusAli: [
    {
      value: 2,
      label: "审核通过"
    },
    {
      value: 5,
      label: "驳回"
    }
  ],
  statusSystem: [
    {
      value: 3,
      label: "线下支付"
    },
    {
      value: 5,
      label: "驳回"
    }
  ],
  operation: [
    {
      value: 1,
      label: "线下支付"
    },
    {
      value: 2,
      label: "支付成功"
    },
    {
      value: 3,
      label: "支付失败"
    }
  ],
  refundOption: [
    {
      value: 1,
      label: "审核通过"
    },
    {
      value: 4,
      label: "驳回申请"
    },
    {
      value: 3,
      label: "线下退款"
    }
  ],
  authScoOption:[
    {
      value: 1,
      label: "小程序"
    },
    {
      value: 2,
      label: "API"
    },
    {
      value: 3,
      label: "E签宝-人脸"
    },
    {
      value: 4,
      label: "E签宝-短信"
    },
    {
      value: 5,
      label: "认证不限制"
    }
  ],
  authStaOption:[
    {
      value: 0,
      label: "审核中"
    },
    {
      value: 1,
      label: "已认证",
      name: "已签署"  // e签宝
    },
    {
      value: 2,
      label: "已驳回",
      name: "拒绝签署"
    },
    {
      value: 3,
      label: "待签署"
    },
    {
      value: 4,
      label: "已撤销"
    },
    {
      value: 5,
      label: "已过期"
    }
  ],
  selfOption: [
    {
      value: "0",
      label: "待审核",
    },
    {
      value: "1",
      label: "注册中",
    },
    {
      value: "3",
      label: "注册完成",
    },
    {
      value: "2",
      label: "已驳回",
    },
  ],
  typeOptions: [
    {
      value: 1,
      label: "商户入驻"
    },
    {
      value: 2,
      label: "代理商入驻"
    },
    {
      value: 3,
      label: "资金入驻"
    },
    {
      value: 4,
      label: "快速咨询"
    },
  ],
  isContactArr: [
    {
      value: "0",
      label: "待接待",
    },
    {
      value: "1",
      label: "已接待",
    },
    {
      value: "2",
      label: "已完结",
    },
  ],
  recordOption: [
    {
      value: "0",
      label: "审核中",
    },
    {
      value: "1",
      label: "已发放",
    },
    {
      value: "2",
      label: "已驳回",
    },
  ],
  checkOption: [
    {
      value: "1",
      label: "待审核",
    },
    {
      value: "2",
      label: "已撤销",
    },
    {
      value: "3",
      label: "已注销",
    },
  ],
  callbackOption: [
    {
      value: "certification",
      label: "个人认证通知地址"
    },
    {
      value: "recharge",
      label: "充值通知地址"
    },
    {
      value: "invoice",
      label: "发票通知地址"
    },
    {
      value: "acceptance_documents",
      label: "验收文件通知地址"
    },
    {
      value: "sign_apply",
      label: "单笔支付通知地址"
    },
    {
      value: "e_sign",
      label: "API签约回调"
    },
    {
      value: "merchant_info",
      label: "商户信息回调"
    },
  ],
  balanOption: [
    {
      value: "1",
      label: "收入"
    },
    {
      value: "2",
      label: "支出"
    },
  ],
  recordOpts: [
    {
      value: "0",
      label: "待审核",
    },
    {
      value: "1",
      label: "已充值",
    },
    {
      value: "2",
      label: "已驳回",
    },
    {
      value: "3",
      label: "已退回",
    },
  ],
  auditOption: [
    {
      value: "0",
      label: "已提交",
    },
    {
      value: "1",
      label: "已开票",
    },
    {
      value: "2",
      label: "已驳回",
    },
    {
      value: "6",
      label: "已作废",
    },
  ],
  billOption: [
    {
      value: "2",
      label: "增值税专用电子发票",
    },
    {
      value: "1",
      label: "增值税普通电子发票",
    },
  ],
  statusOption: [
    {
      value: "0",
      label: "生成中",
    },
    {
      value: "1",
      label: "已生成",
    },
    {
      value: "2",
      label: "生成失败",
    },
  ]
}



// WEBPACK FOOTER //
// ./src/utils/options.js